import uuid from 'uuid/v4';
import createReducer from 'shared/utils/createReducer';

import { CONSULTATION_PARAMS } from '../actions/startConsultation';

const defaultState = {
  applicationId: '',
  consultationId: '',
  instanceId: uuid(),
  userId: '',
  deviceId: uuid(),
  mediaGatewayUrl: '',
  jwtRegister: '',
  jwtJoin: '',
  channel: '',
};

export default createReducer(defaultState, {
  [CONSULTATION_PARAMS]: (state, { payload }) => ({
    ...state,
    ...payload,
  }),
});
